// extracted by mini-css-extract-plugin
export default {"trafficLegend":"qJJUg","title":"tnGAn","yellow":"fTULR","orange":"ChtuL","red":"Kvb4V","darkred":"QYMeT","black":"QxDi8","left":"D4aSG","right":"bm9rv"};